import axiosInstance from './axios-instance';

export type InstructionScope = 'global' | 'account' | 'client';

export interface AiInstruction {
  id: number;
  instruction: string;
  accountId?: number | null;
  clientId?: number | null;
  scope?: InstructionScope;
  source?: string | null;
  metadata?: any;
  category?: string | null;
  subcategory?: string | null;
  priority?: number | null;
  status?: 'active' | 'superseded' | 'archived' | 'draft' | string | null;
  appliesTo?: any;
  version?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListInstructionsResponse {
  instructions: AiInstruction[];
}

export interface ListInstructionsParams {
  allAccounts?: boolean;
  accountId?: number;
  clientId?: number;
  includeGlobal?: boolean;
  scope?: InstructionScope;
  category?: string;
  subcategory?: string;
  status?: string;
  priority?: number;
  minPriority?: number;
  maxPriority?: number;
  limit?: number;
}

export interface CreateInstructionRequest {
  instruction: string;
  scope?: InstructionScope;
  accountId?: number | null;
  clientId?: number | null;
  source?: string | null;
  metadata?: any;
  category?: string | null;
  subcategory?: string | null;
  priority?: number | null;
  status?: 'active' | 'superseded' | 'archived' | 'draft' | string | null;
  appliesTo?: any;
  version?: number | null;
  feedbackIds?: number[];
}

export interface CreateInstructionResponse {
  instruction: AiInstruction;
}

export interface UpdateInstructionRequest {
  id: number;
  instruction?: string;
  scope?: InstructionScope;
  accountId?: number | null;
  clientId?: number | null;
  source?: string | null;
  metadata?: any;
  category?: string | null;
  subcategory?: string | null;
  priority?: number | null;
  status?: 'active' | 'superseded' | 'archived' | 'draft' | string | null;
  appliesTo?: any;
  version?: number | null;
}

export interface UpdateInstructionResponse {
  instruction: AiInstruction;
}

export interface DeleteInstructionResponse {
  deleted: boolean;
  id: number;
}

export const listAiInstructions = async (
  params: ListInstructionsParams = {}
): Promise<AiInstruction[]> => {
  const { data } = await axiosInstance.get<ListInstructionsResponse>('/ai/instructions', {
    params,
  });
  return data?.instructions || [];
};

export const createAiInstruction = async (
  payload: CreateInstructionRequest
): Promise<AiInstruction> => {
  const { data } = await axiosInstance.post<CreateInstructionResponse>('/ai/instruction', payload);
  return data.instruction;
};

export const updateAiInstruction = async (
  payload: UpdateInstructionRequest
): Promise<AiInstruction> => {
  const { data } = await axiosInstance.patch<UpdateInstructionResponse>('/ai/instruction', payload);
  return data.instruction;
};

export const deleteAiInstruction = async (id: number): Promise<DeleteInstructionResponse> => {
  const { data } = await axiosInstance.delete<DeleteInstructionResponse>('/ai/instruction', {
    data: { id },
  });
  return data;
};
